const STORAGE_KEY = "last_accessed";

export type LastAccessed = {
  workspaceId: string | null;
  merchantId: string;
};

export const setLastAccessed = (value: LastAccessed): void => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  // Keep the legacy key in sync so older code paths still work.
  localStorage.setItem("api_key", value.merchantId);
};

export const clearLastAccessed = (): void => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem("api_key");
};

export const getLastAccessed = (): LastAccessed | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as LastAccessed;
  } catch {}
  // Fall back to the legacy api_key value.
  const apiKey = localStorage.getItem("api_key");
  return apiKey ? { workspaceId: null, merchantId: apiKey } : null;
};
